export default "__VITE_ASSET__IX6VpF2i__"